export default __webpack_public_path__ + "static/media/Group9195.90e94789.svg";